module.exports = __webpack_public_path__ + "img/delete.82816171.svg";